<template>
    <div class="password-reset system-notice">
        <h1 class="title">系统公告</h1>
        <base-empty-data v-if="systemInfo.length == 0"></base-empty-data>
        <table class="table-base table-system-notice" v-else>
            <!-- <table class="table-base table-system-notice"> -->
            <tr>
                <th width="300" align="center"><i class="iconfont icon-fenlei"></i> 发布时间</th>
                <th> <i class="iconfont icon-caijishijian"></i>公告标题 </th>
            </tr>
            <tr v-for="(sys, index) in systemInfo" :key="index" @click="viewDetail(sys)">
                <td  align="center">{{sys.createTime}}</td>
                <td style="padding-left:25px">{{sys.noticeTitle}}</td>
            </tr>
        </table>
    </div>
</template>

<script>
    import mixins from '../mixins'
    export default {
        mixins: [mixins],
        data(){
            return {
                systemInfo: {
                    data: []
                }
            }
        },
        mounted(){
            // 获取系统公告
            this.getSystemAnnouncement();
        },
        methods: {
            viewDetail(sys){
                this.$parent.showOutsideComponent('base-systemnoticedetail')
                this.$store.commit('systemData', {
                    componentName: 'base-systemnoticedetail',
                    id: sys.noticeId
                })
            },
            async getSystemAnnouncement(){
              //TODO:
              //this.$store.commit('updateOutComponentLoading', true)
                let result = await this.$http.get('api/notice/list')
                this.$store.commit('updateOutComponentLoading', false)
                if(result){
                    this.systemInfo = result.data.filter( item => item.noticeType == "2");
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/component/base-systemnotice1.vue